<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2"  (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                id="111">
                    <h2>How to Create Payout</h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/Ee8A2oDqDRw?si=wcJ62-H4WxaERYp_"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="111">
                    
                    <label for="" class="mt-2">In this guide, we'll walk you through the process of getting started with payouts on our platform. Whether you're a seasoned user or a newcomer, these steps will help you seamlessly navigate the payout setup.  </label>
                </div>
                <div class="col-md-12 mt-3 " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="112">
                    <div class="mt-3">
                        <b>Step 1:</b> Visit payout.payg.in and log in to your account. If you are new to PayG, sign up and complete the onboarding process on the PayG platform. 
                    </div>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/cp1.png" width="100%" height="80%" alt="">
                        </div>
                        
                    </div>
                    <div class="col-md-12 mt-2">After logging in, a screen will appear, guiding the necessary steps you should follow. </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp2.png" width="100%" height="80%" alt="">
                    </div>
                    <div class=" col-md-12 mt-2 ">
                        <b>Create your virtual account : </b>  PayG will verify your account and generate a virtual account. After verification, merchants can add a balance to it. Merchants can create as many accounts as they want, and they can add an amount to them only after being verified by PayG. 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp3.png" width="50%" height="40%" alt="">
                    </div>
                    <div class="mt-3 ">
                        <b>Step 2:</b> After the account is verified by PayG, the payout dashboard will appear as shown, and the virtual account will be accessible on the dashboard. By clicking on the dropdown menu, merchants can add more accounts.  
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp4.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 3:</b> Add balance to your virtual account by following this step and filling in your account information.  
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp5.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 4:</b> Add new categories by clicking on “Add new category” and insert the category name.
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp6.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 5:</b> To designate contacts as beneficiaries, click on "Add new contacts" once to initiate fund transfers. 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp7.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp8.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 6:</b> Select "Create a Fund Transfer" to send funds to your beneficiaries.
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp9.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp10.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 7:</b> The merchants can add new users by clicking on "Add New User." The admin can create roles and permissions, enabling merchants to generate users as needed. 
                    </div><div class="col-md-12 mt-2  ">
                        <img src="./assets/cp11.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp12.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 8:</b> Merchants can track their transactions on the dashboard and obtain detailed information by clicking on "View Details." 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp13.png" width="100%" height="40%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>Step 9:</b> The merchants can generate a detailed report of their transactions by clicking on “Reports” and can download it.  
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp14.png" width="100%" height="80%" alt="">
                    </div>  
                    
                </div>
                

            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#111">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> How to Create Payout</span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#112">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    How to get started </span>

                            </div>
                        </div>
                    </a>
                </div>
                
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/pay-out']"><button class="btn btn-color" 
                    > <img src="./assets/Arrow 3.svg" alt=""> &nbsp;Payout
                    &nbsp;</button></a> 
               </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/onboarding']">   <button class="btn btn-color" >Onboarding
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>